export enum SseEndpointsSuffixes {
  orders = "vendor/orders/sse",
}
